module.exports = __webpack_public_path__ + "media/images/quote-b81eafcf31206eb401699d0fbd53d672.png";